import { Outlet } from '@/util/react-router-dom';
import { ReferenceDataProvider } from '@/contexts/reference-data-context';

export function ReferenceDataOutlet() {
  return (
    <ReferenceDataProvider>
      <Outlet />
    </ReferenceDataProvider>
  );
}
